import { httpClient } from '~/utils/axios'
import _ from 'lodash';

// dashboard の重複取得を避ける（ホームで起動すると pages/index.vue の mounted と
// plugins/checkUpdate.js の起動1秒後の取得が重なり、同じ内容を2回取っていた）。
// { reuseRecent: true } を付けた呼び出しだけが、取得中の結果を待つ／直近の取得を使い回す。
// store の state に置くと localStorage に保存されるので、モジュール変数で持つ。
const DASHBOARD_REUSE_MS = 5000
let dashboardInflight = null
let dashboardFetchedAt = 0

const getDefaultState = () => {
  return {
    // 予約関連マスタ
    company_groups: [],
    able_companies: [],
    calendars: [],
    resources: [],
    menus: [],

    // その他マスタ
    courses: [],
    item_categories: [],
    items: [],
    training_categories: [],
    training_events: [],
    training_machines: [],
    training_muscles: [],
    client_training_events: [],
    contents: [],
    content_categories: [],
    time_zone: null,
    survey: null,
    goal_term: null,

    // dashboard
    prev_lesson: null,
    next_lesson: null,
    prev_has_data_lesson: null,
    prev_has_data_client_trend: null,
    current_client_trend: null,
    yesterday_client_trend: null,
    streaks: null,
  }
}

export const state = () => (getDefaultState())
export const mutations = {
  setCompanyGroups(state, company_groups) {
    state.company_groups = company_groups
  },
  setAbleCompanies(state, able_companies) {
    state.able_companies = able_companies
  },
  setCalendars(state, calendars) {
    calendars = _.sortBy(calendars, "sort")
    state.calendars = calendars
  },
  setResources(state, resources) {
    resources = _.sortBy(resources, "sort")
    state.resources = resources
  },
  setMenus(state, menus) {
    menus.forEach(m => {
      m.label = `${m.name}/${m.need_ticket_size}枚/${m.max_seat_size}人`
    })
    menus = _.sortBy(menus, "sort")
    state.menus = menus
  },
  setCourses(state, courses) {
    courses.forEach(c => {
      c.label = `${c.name}/${c.ticket_number}枚/${c.price}円`
    })
    courses = _.sortBy(courses, "sort")
    state.courses = courses
  },
  setItemCategories(state, item_categories) {
    item_categories = _.sortBy(item_categories, ["sort"])
    state.item_categories = item_categories
  },
  setItems(state, items) {
    items.forEach(it => {
      it.label = `${it.name_inner} / ${it.price}円(${it.tax_rate}%) / ${it.manage_stock ? '在庫:' + it.stock_size + '個' : null}`
    })
    items = _.sortBy(items, ["sort"])
    state.items = items
  },
  setTrainingCategories(state, training_categories) {
    training_categories = _.sortBy(training_categories, ["sort"])
    state.training_categories = training_categories
  },
  setTrainingEvents(state, training_events) {
    training_events = _.orderBy(
      training_events,
      ['sort', 'id'],
      ['asc', 'desc']
    )
    state.training_events = training_events
  },
  setClientTrainingEvents(state, client_training_events) {
    state.client_training_events = client_training_events
  },
  setContents(state, contents) {
    state.contents = _.orderBy(contents, ['sort', 'id'], ['asc', 'desc'])
  },
  setContentCategories(state, content_categories) {
    state.content_categories = _.sortBy(content_categories, ['position'])
  },
  setTrainingMuscles(state, training_muscles) {
    training_muscles = _.orderBy(
      training_muscles,
      ['sort', 'id'],
      ['asc', 'desc']
    )
    state.training_muscles = training_muscles
  },
  setTrainingMachines(state, training_machines) {
    training_machines = _.orderBy(
      training_machines,
      ['sort', 'id'],
      ['asc', 'desc']
    )
    state.training_machines = training_machines
  },
  setTimeZone(state, time_zone) {
    state.time_zone = time_zone
  },
  clearSurvey(state){
    state.survey = null
  },
  setSurvey(state, survey){
    state.survey = survey
  },

  setGoalTerm(state, goal_term) {
    state.goal_term = goal_term
  },
  setDashboard(state, payload) {
    state.prev_lesson = payload.prev_lesson
    state.next_lesson = payload.next_lesson
    state.prev_has_data_lesson = payload.prev_has_data_lesson
    state.prev_has_data_client_trend = payload.prev_has_data_client_trend
    state.current_client_trend = payload.current_client_trend
    state.yesterday_client_trend = payload.yesterday_client_trend
    state.streaks = payload.streaks
  },
  setCurrentClientTrend(state, current_client_trend) {
    state.current_client_trend = current_client_trend
  },

  reset(state) {
    Object.assign(state, getDefaultState())
  },

  
}
export const getters = {
}
export const actions = {
  // マスタ一式取得
  async getClient(context){
    await httpClient
    .get('/cli/account/show.json')
    .then(async (res) => {
      if (res.data.status === 'success') {
        window.storeCtl.commit("auth/setHeadquarter", res.data.data.headquarter)
        window.storeCtl.commit("auth/setCompany", res.data.data.company)
        window.storeCtl.commit("auth/setClient", res.data.data.client)
        context.commit("setCompanyGroups", res.data.data.company_groups)
        context.commit("setGoalTerm", res.data.data.goal_term)
        context.commit("setCourses", res.data.data.courses)
        context.commit("setItemCategories", res.data.data.item_categories)
        context.commit("setItems", res.data.data.items)
        context.commit("setTrainingCategories", res.data.data.training_categories)
        context.commit("setTrainingEvents", res.data.data.training_events)
        context.commit("setTrainingMuscles", res.data.data.training_muscles)
        context.commit("setTrainingMachines", res.data.data.training_machines)
        window.storeCtl.commit("auth/setClientDocs", res.data.data.client_docs)
      } else {
        window.storeCtl.commit("alert/setError", res.data.message)
      }
    })
  },

  // セッションデータ取得
  // options.reuseRecent: 取得中ならそれを待ち、直近 DASHBOARD_REUSE_MS 以内に取っていれば取り直さない
  // （起動時など「最新でありさえすればよい」呼び出し用。更新の反映が要る呼び出しは付けない）
  async getDashboard(context, options = {}){
    if (options && options.reuseRecent) {
      if (dashboardInflight) return dashboardInflight
      if (Date.now() - dashboardFetchedAt < DASHBOARD_REUSE_MS) return
    }
    const request = httpClient
    .get('/cli/account/dashboard.json')
    .then(async (res) => {
      if (res.data.status === 'success') {
        dashboardFetchedAt = Date.now()
        window.storeCtl.commit("auth/setCompany", res.data.data.company)
        window.storeCtl.commit("auth/setClient", res.data.data.client)
        context.commit("setDashboard", {
          prev_lesson: res.data.data.prev_lesson,
          next_lesson: res.data.data.next_lesson,
          prev_has_data_lesson: res.data.data.prev_has_data_lesson,
          prev_has_data_client_trend: res.data.data.prev_has_data_client_trend,
          current_client_trend: res.data.data.current_client_trend,
          yesterday_client_trend: res.data.data.yesterday_client_trend,
          streaks: res.data.data.streaks,
        })
      } else {
        window.storeCtl.commit("alert/setError", res.data.message)
      }
    })
    .finally(() => {
      if (dashboardInflight === request) dashboardInflight = null
    })
    dashboardInflight = request
    await request
  },

  // survey
  async getSurveyByScene(context, scene){
    context.commit("clearSurvey")
    await httpClient
      .get(`/cli/floor/surveys/get_by_scene.json?use_scene=${scene}`)
      .then(async (res) => {
        if (res.data.status === 'success') {
          let survey = res.data.data.survey
          let survey_questions = res.data.data.survey_questions
          if(survey) survey.survey_questions = _.sortBy(survey_questions, "sort")
          context.commit("setSurvey", survey)
        } else {
          window.storeCtl.commit("alert/setError", res.data.message)
        }
      })
  },
  async getSurveyById(context, uid){
    context.commit("clearSurvey")
    await httpClient
      .get(`/cli/floor/surveys/${uid}.json`)
      .then(async (res) => {
        if (res.data.status === 'success') {
          let survey = res.data.data.survey
          let survey_questions = res.data.data.survey_questions
          survey.survey_questions = _.sortBy(survey_questions, "sort")
          context.commit("setSurvey", survey)
        } else {
          window.storeCtl.commit("alert/setError", res.data.message)
        }
      })
  },

  async getTrainingEvents(context){
    await httpClient
      .get(`/cli/floor/training_events.json`)
      .then(async (res) => {
        if (res.data.status === 'success') {
          context.commit("setTrainingCategories", res.data.data.training_categories)
          context.commit("setTrainingEvents", res.data.data.training_events)
          context.commit("setTrainingMuscles", res.data.data.training_muscles)
          context.commit("setTrainingMachines", res.data.data.training_machines)
          context.commit("setClientTrainingEvents", res.data.data.client_training_events)
        } else {
          window.storeCtl.commit("alert/setError", res.data.message)
        }
      })
  },

  async getContents(context){
    await httpClient
      .get(`/cli/floor/contents.json`)
      .then((res) => {
        if (res.data.status === 'success') {
          context.commit("setContents", res.data.data.contents)
          context.commit("setContentCategories", res.data.data.content_categories)
        } else {
          window.storeCtl.commit("alert/setError", res.data.message)
        }
      })
  },

}
